import React, { Component, Fragment } from 'react';
import { withAsyncActions } from 'react-async-client';
import { Link } from 'react-router-dom';
import { message } from 'antd';

import { Logo, H3 } from './Login';
import { postPasswordRecovery } from '../../actions/asyncActions';
import RecoveryForm from '../forms/RecoveryForm';

class Recovery extends Component {
    render() {
        return <Fragment>
            <Logo />
            <H3>Восстановление пароля</H3>
            <RecoveryForm formAction={this.props.postPasswordRecovery} />
            <Link style={{ marginTop: 15, display: 'inline-block' }} to='/'>Войти</Link>
        </Fragment>;
    }
}

export default withAsyncActions({
    postPasswordRecovery: postPasswordRecovery
        .withSuccessHandler(({ history }) => {
            message.success('Ссылка на востановление пароля успешно отправлена');
            history.push('/');
        })
        .withErrorHandler(() => message.error('Не удалось отправить ссылку на восстановление пароля'))
        .withOptions({ resetOnUnmount: true })
})(Recovery);
